import React from 'react';

import moment from 'moment-timezone';

import { orderStatus, quoteStatus } from '../utils/constant';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import request from '../utils/request';
import FieldGuide from '../form/fields/common/fieldGuide';
import Tag from '../common/tags';
import { MessageOrderLocked } from './css';

const getFinalStatus = (statusQuote, statusOrder) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { status }
  } = localizedStrings;

  let finalStatus;
  let statusId;
  if (
    statusQuote === quoteStatus.incomplete &&
    statusOrder === orderStatus.incomplete
  ) {
    finalStatus = status.incomplete;
    statusId = 'incomplete';
  } else if (
    statusQuote === quoteStatus.pendingApproval &&
    statusOrder === orderStatus.incomplete
  ) {
    finalStatus = status.pending;
    statusId = 'pending';
  } else if (
    statusQuote === quoteStatus.approved &&
    statusOrder === orderStatus.incomplete
  ) {
    finalStatus = status.approved;
    statusId = 'approved';
  } else if (statusOrder === orderStatus.pendingValidation) {
    finalStatus = status.pendingValidation;
    statusId = 'pendingValidation';
  } else if (statusOrder === orderStatus.waitingOnSales) {
    finalStatus = status.waitingOnSales;
    statusId = 'waitingOnSales';
  } else if (statusOrder === orderStatus.waitingOnCredit) {
    finalStatus = status.waitingOnCredit;
    statusId = 'waitingOnCredit';
  } else if (statusOrder === orderStatus.contractSent) {
    finalStatus = status.contractSent;
    statusId = 'contractSent';
  } else if (statusOrder === orderStatus.contractSigned) {
    finalStatus = status.contractSigned;
    statusId = 'contractSigned';
  } else if (statusOrder === orderStatus.contractExpired) {
    finalStatus = status.contractExpired;
    statusId = 'contractExpired';
  } else if (statusOrder === orderStatus.orderCanceled) {
    finalStatus = status.orderCanceled;
    statusId = 'orderCanceled';
  } else if (statusOrder === orderStatus.withConcierge) {
    finalStatus = status.withConcierge;
    statusId = 'withConcierge';
  } else if (statusOrder === orderStatus.validated) {
    finalStatus = status.validated;
    statusId = 'validated';
  } else if (statusOrder === orderStatus.implementationInProgress) {
    finalStatus = status.implementationInProgress;
    statusId = 'implementationInProgress';
  } else if (statusOrder === orderStatus.waitingOnCompletionCall) {
    finalStatus = status.waitingOnCompletionCall;
    statusId = 'waitingOnCompletionCall';
  } else if (statusOrder === orderStatus.orderInstalled) {
    finalStatus = status.orderInstalled;
    statusId = 'orderInstalled';
  }
  return { finalStatus, statusId };
};

const getStatus = ({ status: order, quoteStatus: quote }) => {
  const localizedStrings = useLocalizedStringsContext();

  const {
    srtDashboard: { statusToolTipMessage }
  } = localizedStrings;

  const { finalStatus, statusId } = getFinalStatus(quote, order);

  const getToolTip = () => {
    const message = statusToolTipMessage[statusId];

    return (
      <div className="responsive-table__status">
        {finalStatus}
        <div className="responsive-table__status-guide">
          <FieldGuide tooltip={message} />
        </div>
      </div>
    );
  };

  return { statusId, finalStatus, statusToolTip: getToolTip() };
};

const getMessage = (data, callback) => {
  const { id, isContractResend, isOrderReturned, isLockedBy } = data;
  const { email } = request.getProfile();
  const localizedStrings = useLocalizedStringsContext();
  const {
    sovTableMessages: { resendContract, returnOrder }
  } = localizedStrings.ORDERS;
  return (
    <div className="responsive-table__messages">
      {isContractResend && (
        <Tag
          orderId={id}
          tagKey="isContractResend"
          tagLabel={resendContract}
          callback={callback}
        />
      )}
      {isOrderReturned && (
        <Tag
          orderId={id}
          tagKey="isOrderReturned"
          tagLabel={returnOrder}
          callback={callback}
        />
      )}
      {isLockedBy && isLockedBy !== email && (
        <MessageOrderLocked>
          This order is being currently worked on by {isLockedBy}
        </MessageOrderLocked>
      )}
    </div>
  );
};

const getLocalFormattedTime = (date, format = 'MM/DD/YYYY, hh:mm A') => {
  const localZone = moment.tz.guess();

  return `${moment
    .utc(date)
    .local()
    .format(format)} ${moment.tz.zone(localZone).abbr(360)}`;
};

const getLastComment = data => {
  if (data.length <= 40) return data;

  let comment = data.substring(0, 39);
  comment += '...';
  return (
    <>
      {comment}
      <div className="responsive-table__comment-guide">
        <FieldGuide tooltip={data} />
      </div>
    </>
  );
};

export { getStatus, getMessage, getLocalFormattedTime, getLastComment };
